import React from 'react';
import { FieldToggle } from '.';
import { FieldToggleWithReduxProps } from './types';

export const FieldToggleWithRedux = ({
  input,
  meta: { form },
  ...props
}: FieldToggleWithReduxProps) => (
  <FieldToggle {...input} {...props} form={form} />
);
